import { Component, input } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';
import { Priority, priorityToColorMap } from '../../store/segments/types';

@Component({
  selector: 'blindspot-segment',
  styleUrls: ['./segment.component.scss'],
  imports: [NgStyle, NgClass],
  template: `
    <div
      class="segment"
      [ngStyle]="{
        backgroundColor: priorityToColorMap[priority()].background,
        color: priorityToColorMap[priority()].color,
        borderColor: priorityToColorMap[priority()].border,
        outlineColor: priorityToColorMap[priority()].border,
      }"
      [ngClass]="{ hover: handleHover() }"
    >
      {{ segment() }}
    </div>
  `,
})
export class SegmentComponent {
  public segment = input.required<string>();
  public priority = input.required<Priority>();
  public handleHover = input<boolean>();

  protected readonly priorityToColorMap = priorityToColorMap;
}
